import { cleanActionConfig, getCellIds } from "../helpers/main";
import { IAction, IActionConfig, SpreadsheetEvents } from "./../types";
import { actions } from "./ActionsManager";

export class GroupAction implements IAction {
	public config: IActionConfig;
	private _actions: IAction[];

	constructor(config: IActionConfig) {
		this.config = config;
		this._actions = [];
	}

	do() {
		const { spreadsheet, grid, action: command } = this.config;
		const events = spreadsheet.events;
		if (!this._actions.length) {
			let val = this.config.val;
			let valueIndex = 0;
			if (Array.isArray(val)) {
				val = val[valueIndex];
			}
			if (!events.fire(SpreadsheetEvents.beforeAction, [command, cleanActionConfig(this.config)]))
				return;

			spreadsheet.eachCell(cell => {
				const { row, col } = getCellIds(cell, grid);
				if (grid?.isRowHidden(row + 1)) return;
				const newCell = getCellIds(cell, grid);
				const action = new (actions[this.config.action] as any)({
					...this.config,
					row: row || newCell.row,
					col: col || newCell.col,
					cell,
					val,
				});
				this._actions.push(action);

				if (Array.isArray(this.config.val)) {
					if (valueIndex + 1 >= this.config.val.length) {
						valueIndex = 0;
					} else {
						valueIndex += 1;
					}
					val = this.config.val[valueIndex];
				}
			}, this.config.cell);
		}
		for (const action of this._actions) {
			action.do();
		}
		events.fire(SpreadsheetEvents.afterAction, [command, cleanActionConfig(this.config)]);
	}

	undo() {
		const { spreadsheet, action: command } = this.config;
		const events = spreadsheet.events;
		if (!events.fire(SpreadsheetEvents.beforeAction, [command, cleanActionConfig(this.config)])) return;
		for (const action of this._actions) {
			action.undo();
		}
		const firstCell = this.config.cell.split(":")[0];
		spreadsheet.selection.setSelectedCell(firstCell)
		events.fire(SpreadsheetEvents.afterAction, [command, cleanActionConfig(this.config)]);
	}
}
